import { Injectable } from '@angular/core';
import { URLSearchParams, Http } from "@angular/http";
import {Observable} from  "rxjs/Observable";
import { HttpService } from './http-service';
import 'rxjs/add/operator/map';
import {LoadingService} from "./loading-service";
import {AuthStore} from '../stores/auth-store';

/*
  Generated class for the HttpReserveProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class HttpFamilyProvider extends HttpService{

  constructor(protected http: Http, protected loadingService:LoadingService, protected authStore:AuthStore) {
  	super(http, loadingService, authStore);
  }

  /**
   * 記録取得
   */
  getList(conditions): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("condition", JSON.stringify(conditions));
    userParam.set("api", "/families/getList");
    var options = super.buildParam(userParam);

    return super.get(options);
  }

  /**
   * 保存処理
   */
  save(data:object): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/Families/save");
    var options = super.buildParam(userParam);

    return super.post(options, data);
  }

  /**
   * 同意書保存処理
   */
  saveAgreement(data:object): Observable<any> {

        //パラメータ設定
        let userParam = new URLSearchParams();
        userParam.set("api", "/families/saveAgreement");
        var options = super.buildParam(userParam);

        return super.post(options, data);
  }
  /**
   * 親情報取得
   */
  getOne(conditions): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("condition", JSON.stringify(conditions));
    userParam.set("api", "/families/getOne");
    var options = super.buildParam(userParam);

    return super.get(options);
  }

  /**
   * 記録登録処理
   */
  iconSave(data:object, imageKind:number): Observable<any> {

    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("api", "/families/iconSave");
    var options = super.buildParam(userParam);

    return super.post(options, {data: data, imageKind: imageKind});
  }
  /**
   * 同意書日時取得
  */
 getAgreementDate(condition:object): Observable<any> {
    //パラメータ設定
    let userParam = new URLSearchParams();
    userParam.set("condition", JSON.stringify(condition));
    userParam.set("api", "/Families/getAgreementDate");
    userParam.set("needLoading", condition["needLoading"]);
    var options = super.buildParam(userParam);

    return super.get(options);
  }
}



// WEBPACK FOOTER //
// ./src/providers/http-family.ts